import { useRouteMatch } from 'react-router-dom';
import { ANALYTICS_SCREEN_NAMES } from '../constants/analytics';
import {
  ROOT,
  SEARCH,
  FAVORITES,
  RECENT_GAMES,
  HALL_OF_FAME,
  HALL_OF_FAME_HISTORY,
  PROVIDER_LIST,
  PROVIDER_DETAIL,
  PROVIDER_DETAIL_PAGINATED,
  CATEGORY_LIST,
  CATEGORY_DETAIL,
  CATEGORY_DETAIL_PAGINATED,
  THEME_LIST,
  THEME_DETAIL,
  THEME_DETAIL_PAGINATED,
  BONUSES_LIST,
  BONUSES_HISTORY,
  BONUS_GAMES_WAGERING,
  BONUS_GAMES_COLLECTING,
  BONUS_DETAIL,
  CAMPAIGN_DETAIL,
  OLD_BONUS_GAMES,
  OLD_BONUS_DETAIL,
  OLD_CAMPAIGN_DETAIL,
  GAME_DETAIL,
  DEMO_GAME_DETAIL,
  COMMON_ERROR,
  SERVER_ERROR,
  NOT_FOUND,
  UNAUTHORIZED,
  NO_MATCH,
} from '../constants/routeTemplates';

const map = {
  [ROOT]: ANALYTICS_SCREEN_NAMES.MAIN,
  [SEARCH]: ANALYTICS_SCREEN_NAMES.SEARCH_PAGE,
  [FAVORITES]: ANALYTICS_SCREEN_NAMES.FAVORITE,
  [RECENT_GAMES]: ANALYTICS_SCREEN_NAMES.RECENT_PROVIDER,
  [HALL_OF_FAME]: ANALYTICS_SCREEN_NAMES.HALL_OF_FAME,
  [HALL_OF_FAME_HISTORY]: ANALYTICS_SCREEN_NAMES.HALL_OF_FAME,
  [PROVIDER_LIST]: ANALYTICS_SCREEN_NAMES.ALL_PROVIDER,
  [PROVIDER_DETAIL]: ANALYTICS_SCREEN_NAMES.DETAIL_PROVIDER,
  [PROVIDER_DETAIL_PAGINATED]: ANALYTICS_SCREEN_NAMES.DETAIL_PROVIDER,
  [CATEGORY_LIST]: ANALYTICS_SCREEN_NAMES.ALL_CATEGORY,
  [CATEGORY_DETAIL]: ANALYTICS_SCREEN_NAMES.DETAIL_CATEGORY,
  [CATEGORY_DETAIL_PAGINATED]: ANALYTICS_SCREEN_NAMES.DETAIL_CATEGORY,
  [THEME_LIST]: ANALYTICS_SCREEN_NAMES.ALL_THEME,
  [THEME_DETAIL]: ANALYTICS_SCREEN_NAMES.DETAIL_THEME,
  [THEME_DETAIL_PAGINATED]: ANALYTICS_SCREEN_NAMES.DETAIL_THEME,
  [BONUSES_LIST]: ANALYTICS_SCREEN_NAMES.BONUS,
  [BONUSES_HISTORY]: ANALYTICS_SCREEN_NAMES.BONUS,
  [BONUS_GAMES_WAGERING]: ANALYTICS_SCREEN_NAMES.BONUS_WAGERING,
  [BONUS_GAMES_COLLECTING]: ANALYTICS_SCREEN_NAMES.BONUS_COLLECTION,
  [BONUS_DETAIL]: ANALYTICS_SCREEN_NAMES.BONUS,
  [CAMPAIGN_DETAIL]: ANALYTICS_SCREEN_NAMES.BONUS,
  [OLD_BONUS_GAMES]: ANALYTICS_SCREEN_NAMES.BONUS,
  [OLD_BONUS_DETAIL]: ANALYTICS_SCREEN_NAMES.BONUS,
  [OLD_CAMPAIGN_DETAIL]: ANALYTICS_SCREEN_NAMES.BONUS,
  [GAME_DETAIL]: ANALYTICS_SCREEN_NAMES.OPEN_GAME,
  [DEMO_GAME_DETAIL]: ANALYTICS_SCREEN_NAMES.OPEN_GAME,
  [COMMON_ERROR]: ANALYTICS_SCREEN_NAMES.ERROR,
  [SERVER_ERROR]: ANALYTICS_SCREEN_NAMES.ERROR,
  [NOT_FOUND]: ANALYTICS_SCREEN_NAMES.ERROR,
  [UNAUTHORIZED]: ANALYTICS_SCREEN_NAMES.ERROR,
  [NO_MATCH]: ANALYTICS_SCREEN_NAMES.ERROR,
};

export const useAnalyticsScreenName = () => {
  const { path } = useRouteMatch();

  return map?.[path] ?? '';
};
